import { render, staticRenderFns } from "./after.vue?vue&type=template&id=d35bb6aa&scoped=true"
import script from "./after.vue?vue&type=script&lang=js"
export * from "./after.vue?vue&type=script&lang=js"
import style0 from "./after.vue?vue&type=style&index=0&id=d35bb6aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35bb6aa",
  null
  
)

export default component.exports